<a
  [routerLink]="link"
  class="link"
  [class.is-collapsed]="isCollapsed"
  [class.on-pill]="onPill"
  routerLinkActive="is-active"
  ariaCurrentWhenActive="page"
  [matTooltip]="tooltip"
  matTooltipPosition="right"
  [matTooltipShowDelay]="200"
>
  <span class="bk-sym link__icon" aria-hidden="true">{{ iconName }}</span>
  <span class="link__label">{{ title }}</span>
  @if (badge > 0) {
    <span class="link__badge" aria-hidden="true">{{ badge > 99 ? '99+' : badge }}</span>
    @if (badgeLabel) {
      <span class="bk-sr-only">, {{ badgeLabel }}</span>
    }
  }
</a>
